import type theme from '#build/ui/table'
import type { DeepPartial } from '@nuxt/ui'

const table: DeepPartial<typeof theme> = {
  slots: {
    root: 'rounded-lg border border-cvt-cloud-800',
    thead: '[&>tr]:after:h-0.5 [&>tr]:after:bg-cvt-text-black',
    tbody: 'divide-cvt-cloud-800',
    tr: 'divide-x divide-cvt-cloud-800 data-[selected=true]:bg-cvt-cloud-800/50',
    th: 'bg-cvt-cloud-200 px-4 py-3.5 text-left text-cvt-text-black cvt-typography-sub1! rtl:text-right [&:has([role=checkbox])]:pe-0',
    td: 'whitespace-nowrap p-4 cvt-typography-body! text-cvt-text-black [&:has([role=checkbox])]:pe-0',
    empty: 'py-6 text-center text-sm text-cvt-text-black',
  },
  compoundVariants: [{
    loading: true,
    loadingColor: 'primary',
    class: {
      thead: 'after:cvt-gradient-base',
    },
  }, {
    loading: true,
    loadingColor: 'neutral',
    class: {
      thead: 'after:bg-old-neutral-900',
    },
  }],
}

export default table
